module.exports = __webpack_public_path__ + "static/pointing-up-951c1d7f7b8d0daf3bacc2655a26295f.png";